import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { ModernCommerce } from './pages/ModernCommerce';
import { AppsDivision } from './pages/AppsDivision';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Careers } from './pages/Careers';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-[#F2F4F0] flex flex-col" data-id="element-2">
        <Header data-id="element-3" />

        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/modern-commerce" element={<ModernCommerce data-id="element-8" />} data-id="element-7" />
          <Route path="/apps-division" element={<AppsDivision data-id="element-10" />} data-id="element-9" />
          <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
          <Route path="/careers" element={<Careers data-id="element-14" />} data-id="element-13" />
          <Route path="/contact" element={<Contact data-id="element-16" />} data-id="element-15" />
        </Routes>

        <Footer data-id="element-17" />
      </div>
    </Router>;
}